import React from 'react';

export function StepNoteDateLabel() {
  return <>Poznámka a datum změny provozovatele</>;
}
